import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';
import { PackageService } from '@services/packages/package.service';

@Component({
    selector: 'ibextv-app',
    templateUrl: './ibextv-app.component.html',
    styleUrls: ['./ibextv-app.component.scss'],
    providers: [DeeplTranslationService, PackageService],
    standalone: false
})
export class IbexTVAppComponent implements OnInit {

  @Input() item: any;
  @Input() packageId: any;
  codeEditorOptions = { maxLines: 30, minLines: 20, fontSize: '16px', autoScrollEditorIntoView: false };
  superadmin = false;

  constructor(private translate: TranslateService, private translation: DeeplTranslationService, private ms: MessengerService, private packageService: PackageService) {
    this.translate.get('general');
    this.ms.$superadminPrivileges.subscribe(privileges => {
      this.superadmin = !!(privileges || []).find(el => el.privilegeName === 'superadmin' && el.value === 'packages');
    });
  }

  async ngOnInit() {
    const pak = await this.packageService.get(this.packageId);
    (pak.availableLanguagesCached || []).forEach(l => {
      if (!this.item.translations.find(t => t.language === l)) {
        this.item.translations.push({ language: l, hidden: this.item.translations[0].hidden, appTitle: this.item.translations[0].appTitle });
      }
    });
  }

  clearInterval() {
    this.item.from = null;
    this.item.to = null;
  }

  async translateText(translation, language, field) {
    translation[field] = await this.translation.translate(this.item.translations.find(el => el.language === 'de')[field], language, this.packageId);
  }

  getTitle() {
    return this.item?.translations?.find(el => el.language === 'de')?.appTitle ?? '';
  }
}
